import { observer } from 'mobx-react';
import { RootState } from '../../state/RootState';
import { GrantSPPermissions } from './GrantSPPermissions';
import { Label, Spinner, SpinnerSize } from '@fluentui/react';
import React from 'react';
import MobileAttachmentsHarness from '../../outlook/MobileAttachmentsHarness';
import OutlookCtrl from '../../outlook/OutlookCtrl';
import StandaloneSearchTab from './StandaloneSearchTab';
import StandaloneDocumentViewerTab from './StandaloneDocumentViewerTab';
import EntityDashboard from '../dashboards/EntityDashboard';
import EntityDashboardState from '../../state/EntityDashboardState';
import { Pages } from '../../Pages';

interface IPageRouterProps {
	rootState: RootState;
}

class PageRouter extends React.Component<IPageRouterProps, {}> {
	componentDidMount(): void {
		this.props.rootState.initialize();
	}

	render() {
		if (
			this.props.rootState.isUserInfoLoading ||
			!this.props.rootState.isUserInfoLoaded
		)
			return <Spinner size={SpinnerSize.large} />;

		return (
			<div style={{ paddingTop: 10, paddingLeft: 10 }}>
				{this.getPage(this.props.rootState)}
			</div>
		);
	}

	private getPage(rootState: RootState) {
		let pageSlug = rootState.page || '';

		if (pageSlug.startsWith(Pages.documentViewer)) {
			return <StandaloneDocumentViewerTab RootState={rootState} />;
		}

		if (pageSlug.startsWith(Pages.search) && rootState.searchTab) {
			return <StandaloneSearchTab state={rootState.searchTab} />;
		}

		/*
		if (pageSlug.startsWith('teamsEntryPoint') && rootState.workspaceRequestPage) {
			return <WorkspaceRequestPage state={rootState.workspaceRequestPage} />;
		}*/

		if (pageSlug.startsWith('code=') || pageSlug.startsWith('id_token=')) {
			//We've just completed granting permissions, so refresh the page
			window.location.href = 'https://' + window.location.host;
			return <Spinner />;
		}

		if (rootState.spAuth.serverConnectionLost)
			return <Label>Server connection lost. Please refresh and try again.</Label>;

		if (!rootState.isUserInfoLoaded) return <Spinner></Spinner>;

		if (pageSlug.startsWith(Pages.mail)) {
			if (pageSlug.endsWith('Harness')) {
				if (rootState.mailHarness) {
					return <MobileAttachmentsHarness state={rootState.mailHarness} />;
				}
			} else {
				if (rootState.mailOutlook) {
					return <OutlookCtrl state={rootState.mailOutlook} />;
				}
			}
		}

		if (rootState.spAuth.spAuthRequired)
			return <GrantSPPermissions RootState={rootState}></GrantSPPermissions>;

		if (pageSlug.startsWith(Pages.view) && rootState.userConfig) {
			let state = new EntityDashboardState(
				rootState.argument || '',
				rootState.userConfig,
			);
			return <EntityDashboard key={state.getConfig().id} state={state} />;
		}

		return <div>page not found: {rootState.page}</div>;
	}
}

export default observer(PageRouter);
